<template>
  <smd-one-col-layout class="auth"
                      content-styles="auth__content">
    <div class="auth-container flex-col">
      <div class="flex-col--center-x">
        <h2 class="Body2 gray-400">WELCOME TO</h2>
        <div class="row">
          <img class="now-serving-logo"
               :src="nowServingLogo">
        </div>
      </div>

      <!--  FORM CONTAINER - !REGISTER -->
      <div class="col form-container m-b-30" v-if="!registerMode">
        <div class="smd-form__row field-max-250">
          <h3 class="auth__title text-center">Enter your mobile number and get started</h3>
        </div>

        <form @submit.prevent="handleValidateMobileNum" novalidate>
          <div class="smd-form__row justify-content-center m-b-10">
            <div class="smd-form__col auth_phone-input__container field-max-250">
              <smd-phone-input class="auth_phone-input"
                               ref="mobilenumber"
                               v-model="$v.mobilenumber.$model"
                               :hide-country-code="false"/>
            </div>
          </div>

          <div v-if="error" class="smd-form__row reset-m">
            <div class="smd-form__col">
              <p class="error">{{ error }}</p>
            </div>
          </div>

          <smd-btn class="auth__continue-btn m-t-15"
                   type="submit"
                   section="4"
                   :variant="buttonVariant"
                   :is-loading="requestOnGoing"
                   :disabled="disabledButton">
            <text-string label-id="txt100"/>
          </smd-btn>
        </form>
      </div>

      <hr v-if="!registerMode">

      <!--      IMAGE CONTAINER -->
      <div class="img-container">
        <!--        BOOK -->
        <div v-for="(item, index) in $options.bookConsultOrderObj"
             class="smd-form__row align-items-center m-s"
             :key="index">
          <div class="img-box">
            <img :src="item.img_src">
          </div>
          <div class="col">
            <h2 class="Body2">{{ item.title }}</h2>
            <p class="Label1 gray-400">{{ item.subtitle }}</p>
          </div>
        </div>
      </div>

      <hr v-if="registerMode">

      <!--        FORM CONTAINER - REGISTER-->
      <div class="col form-container m-t-20" v-if="registerMode">
        <div class="mb-m">
          <p>You are logging in with this mobile number:</p>
          <p class="blue mb-s">{{ mobilenumber }}</p>

          <span>Please complete the following details to proceed.</span>
        </div>

        <form @submit.prevent="validateRegistration" novalidate>
          <div v-if="error" class="smd-form__row reset-m">
            <div class="smd-form__col">
              <p class="error">{{ error }}</p>
            </div>
          </div>

          <div class="smd-form__row">
            <div class="smd-form__col">
              <label for="firstname">First Name</label>
              <input type="text"
                     id="firstname"
                     v-model="$v.firstname.$model">
            </div>
          </div>

          <div v-if="submitAttempted && validationErrors.firstname"
               class="smd-form__row validation-error">
            <small class="error">
              {{ validationErrors.firstname }}
            </small>
          </div>

          <!--          MIDDLE NAME -->
          <div class="smd-form__row">
            <div class="smd-form__col">
              <label for="middlename">Middle Name</label>
              <input type="text"
                     id="middlename"
                     ref="middlename"
                     v-model.trim="$v.middlename.$model">
            </div>
          </div>

          <div v-if="submitAttempted && validationErrors.middlename"
               class="smd-form__row validation-error">
            <small class="error">
              {{ validationErrors.middlename }}
            </small>
          </div>

          <!--          LAST NAME -->
          <div class="smd-form__row">
            <div class="smd-form__col">
              <label for="lastname">Last Name</label>
              <input type="text"
                     id="lastname"
                     ref="lastname"
                     v-model.trim="$v.lastname.$model">
            </div>
          </div>

          <div v-if="submitAttempted && validationErrors.lastname"
               class="smd-form__row validation-error">
            <small class="error">
              {{ validationErrors.lastname }}
            </small>
          </div>

          <!--          BIRTHDATE -->
          <div class="smd-form__row">
            <div class="smd-form__col">
              <label for="birthdate">Birthday</label>
              <smd-date-input v-model="$v.birthdate.$model"
                              id="birthdate"
                              ref="birthdate"
                              :format-emitted-date="'MM/DD/YYYY'"/>
            </div>
          </div>

          <div v-if="submitAttempted && validationErrors.birthdate"
               class="smd-form__row validation-error">
            <small class="error">
              {{ validationErrors.birthdate }}
            </small>
          </div>

          <!--          EMAIL -->
          <div class="smd-form__row">
            <div class="smd-form__col">
              <label for="email">Email</label>
              <input type="email"
                     id="email"
                     ref="email"
                     placeholder="(Optional)"
                     v-model.trim="$v.email.$model">
            </div>
          </div>

          <div v-if="submitAttempted && validationErrors.email"
               class="smd-form__row validation-error">
            <small class="error">
              {{ validationErrors.email }}
            </small>
          </div>

          <!--          TERMS & PRIVACY-->
          <div class="smd-form__row">
            <div class="smd-checkbox__row">
              <smd-checkbox v-model="$v.termsAgreed.$model">
                <span class="Body1 black">
                  I have read, understood, and accepted the
                  <a target="_blank"
                     class="terms-privacy-btn"
                     href="https://nowserving.seriousmd.com/terms-of-use/">
                    Terms & Conditions
                  </a>.
                </span>
              </smd-checkbox>
            </div>
          </div>

          <div v-if="submitAttempted && validationErrors.termsAgreed"
               class="smd-form__row no-flex validation-error">
            <small class="error"
                   v-if="submitAttempted && validationErrors.termsAgreed">
              {{ validationErrors.termsAgreed }}
            </small>
          </div>

          <div class="smd-form__row">
            <div class="smd-checkbox__row">
              <smd-checkbox v-model="$v.privacyAgreed.$model">
                <span class="Body1 black">
                  I have read, understood, and accepted the
                  <a target="_blank"
                     class="terms-privacy-btn"
                     href="https://nowserving.seriousmd.com/privacy-policy/">
                    Privacy & Policy
                  </a>.
                </span>
              </smd-checkbox>
            </div>
          </div>

          <div v-if="submitAttempted && validationErrors.privacyAgreed"
               class="smd-form__row no-flex validation-error">
            <small class="error">
              {{ validationErrors.privacyAgreed }}
            </small>
          </div>

          <smd-btn class="auth__submit-btn"
                   type="submit"
                   section="4"
                   :variant="buttonVariant"
                   :is-loading="requestOnGoing"
                   :disabled="disabledButton"
                   @click="toggleSubmitAttempted">
            <text-string label-id="txt575"/>
          </smd-btn>
        </form>
      </div>

      <vue-hcaptcha :sitekey="$options.siteKey"
                    ref="hcaptcha"
                    size="invisible"
                    @error="onHcaptchaError"
                    @verify="onHcaptchaVerify">
      </vue-hcaptcha>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import {AuthService, RESPONSE_ENUM} from '@/services/auth-service';
  import {OtpService, OTP_RESPONSE_ENUM} from '@/services/otp';
  import {HOME_ROUTE} from '@/router/routes';
  import {setAccessToken, getTokenProp} from '@/utils/access-token';
  import {logger, setUserContext} from '@/utils/logger';
  import {bus} from '@/main';
  import {
    SHOW_OTP_EVENT,
    CLOSE_OTP_EVENT,
    OTP_CLOSED_EVENT,
    OTP_SUCCESS_EVENT,
  } from '@/constants/bus';

  import formValidationMixin from '@/mixins/form-validations';
  import hcaptchaMixin from '@/mixins/hcaptcha-mixin';

  import {required, email} from 'vuelidate/lib/validators';
  import {
    alphaSpaces,
    mobileNumberValid,
    dateStringIsValid,
    dateStringIsLessThan,
    requiredCheckBox,
  } from '@/utils/custom-validations';
  import {censorMobileNumber} from '@/utils';

  import BookImage from '@/assets/images/icon-book-calendar.png';
  import OrderImage from '@/assets/images/icon-order-medicine.png';
  import ConsultImage from '@/assets/images/icon-consult.png';
  import NowServingLogo from '@/assets/images/now-serving-logo-horizontal.svg';
  import GetElementString from '@/mixins/get-element-string'

  const todayInMilli = (new Date()).setHours(0, 0, 0, 0).valueOf();

  export default {
    name: 'Auth',
    mixins: [
      hcaptchaMixin,
      formValidationMixin,
      GetElementString
    ],
    props: {
      initialError: {type: String, default: null},
    },
    data() {
      return {
        error: this.initialError,
        requestOnGoing: false,
        registerMode: false,
        noOnRegisterMode: null,
        pendingMobileRegistration: null,

        firstname: '',
        middlename: '',
        lastname: '',
        birthdate: '',
        mobilenumber: '',
        email: '',

        termsAgreed: false,
        privacyAgreed: false,

        nowServingLogo: NowServingLogo,
      };
    },
    computed: {
      disabledButton() {
        return this.requestOnGoing;
      },
      buttonVariant() {
        return this.disabledButton ? 'blue-disabled' : 'blue-enabled';
      },
    },
    watch: {
      registerMode(newRegisterModeValue) {
        if (newRegisterModeValue === false) {
          this.firstname = '';
          this.middlename = '';
          this.lastname = '';
          this.birthdate = '';
          this.email = '';
        }
      },
    },
    mounted() {
      bus.$on(OTP_SUCCESS_EVENT, this.onVerifySuccess);
      bus.$on(OTP_CLOSED_EVENT, this.onOtpClosed);
    },
    destroyed() {
      bus.$off(OTP_SUCCESS_EVENT);
      bus.$off(OTP_CLOSED_EVENT);
    },
    methods: {
      handleValidateMobileNum() {
        this.$v.$touch();
        if (!this.$v.mobilenumber.mobileNumberValid) {
          this.error = this.getElementString('txt299')
        } else {
          this.handleAuthentication();
        }
      },
      toggleSubmitAttempted() {
        this.submitAttempted = true;
      },
      validateRegistration() {
        this.error = "";

        //FORM VALIDATION
        this.$v.$touch();

        if (this.registerMode && this.$v.$invalid) {
          this.focusOnFieldWithError();
        } else {
          this.handleAuthentication();
        }
      },
      async doRegister(payload) {
        return await AuthService.register({
          ...payload,
          agent: 'web3',
          captchatoken: this.validateToken,
        })
      },
      async doLogin(payload) {
        return await AuthService.login({
          ...payload,
          agent: 'web3',
          captchatoken: this.validateToken,
        })
      },
      postHcaptchaVerify() {
        this.handleAuthentication();
      },
      async handleAuthentication() {
        this.requestOnGoing = true;

        if (!this.validateToken) {
          this.triggerCaptcha();
          return;
        }

        this.error = '';

        //REQUEST
        const {
          firstname,
          middlename,
          lastname,
          birthdate,
          mobilenumber,
          email,
        } = this;
        const mode = this.registerMode ? 'register' : 'login';

        try {
          const {data: responseData} = this.registerMode
            ? await this.doRegister({
                firstname,
                middlename,
                lastname,
                birthdate,
                mobilenumber,
                email
              })
            : await this.doLogin({mobilenumber: this.mobilenumber});
          const {
            GENERAL_ERROR,
            CODE_ALREADY_SENT,
            MOBILE_NOT_REGISTERED,
            PENDING_REGISTRATION,
          } = RESPONSE_ENUM.AUTH;
          const {
            SUCCESS_LOGIN_RESEND,
            SUCCESS_REGISTER_RESEND,
            RESEND_RECENTLY_SENT_CODE,
          } = OTP_RESPONSE_ENUM.RESEND;

          const logContext = {
            mode,
            result: responseData.result,
            status: responseData.status,
            onPendingRegistration: !!this.pendingMobileRegistration
              && this.pendingMobileRegistration === this.mobilenumber,
            hasVerifyToken: !!responseData.verifytoken,
            hasMobileVerifyToken: !!responseData.mobileverifytoken,
            responseKeys: Object.keys(responseData),
          };
          logger.info('Auth request response', logContext);

          if (responseData.result === MOBILE_NOT_REGISTERED) {
            this.registerMode = true;
          } else if (responseData.result === GENERAL_ERROR) {
            logger.warn('Auth request general error', {...logContext, field: 'result'});
            this.error = this.getAuthErrorMessage();
          } else if (responseData.status === GENERAL_ERROR) {
            logger.warn('Auth request general error', {...logContext, field: 'status'});
            this.error = 'Unable to reach mobile number at this time. Please try again later.';
          } else {
            const onPendingRegistration = !!this.pendingMobileRegistration && (this.pendingMobileRegistration === this.mobilenumber);
            const registeringRequest = onPendingRegistration || this.registerMode;
            const {
              EXPIRED,
              FAILED,
              VERIFY_SUCCESS,
            } = OTP_RESPONSE_ENUM.VERIFY;
            const otpProps = {
              sentTo: censorMobileNumber(this.mobilenumber),
              resendRequestBody: {
                mobilenumber: this.mobilenumber,
              },
              initialVerifyToken: responseData.verifytoken,
              verifyApiService: registeringRequest
                ? OtpService.registerVerify
                : OtpService.loginVerify,
              resendApiService: registeringRequest
                ? OtpService.registerResend
                : OtpService.loginResend,
              successResendCodes: registeringRequest
                ? [SUCCESS_LOGIN_RESEND, SUCCESS_REGISTER_RESEND]
                : [SUCCESS_LOGIN_RESEND],
              failedResendCodes: {
                [RESEND_RECENTLY_SENT_CODE]: 'Requested code recently. Please wait for 1 minute after the last request.',
              },
              successVerifyCodes: [VERIFY_SUCCESS],
              failedVerifyCodes: {
                [EXPIRED]: 'Verification code is already expired.',
                [FAILED]: 'Invalid verification code.',
              },
            };

            if (responseData.result === CODE_ALREADY_SENT) {
              otpProps.initialError = 'Requested code recently. Please check your mobile device for verification code.';
            } else if (responseData.result === PENDING_REGISTRATION) {
              this.pendingMobileRegistration = this.mobilenumber;
              otpProps.initialVerifyToken = responseData.mobileverifytoken || responseData.verifytoken;
              otpProps.verifyApiService = OtpService.registerVerify;
              otpProps.resendApiService = OtpService.registerResend;
            }

            bus.$emit(SHOW_OTP_EVENT, otpProps);
          }

          this.requestOnGoing = false;
        } catch (error) {
          logger.error('Auth request failed', {
            mode,
            status: error.response && error.response.status,
            isNetworkError: !error.response,
          }, error);
          this.requestOnGoing = false;
          this.error = this.getAuthErrorMessage();
        } finally {
          // Treat captcha tokens as single-use: never resend one after /login or /register has seen it.
          this.validateToken = null;
        }
      },
      getAuthErrorMessage() {
        return this.registerMode
          ? 'Unable to register at this time. Please try again later.'
          : 'Unable to log in at this time. Please try again later.';
      },
      onVerifySuccess(accessToken) {
        setAccessToken(accessToken);
        const accountId = getTokenProp('accountid');
        if (accountId) setUserContext(accountId);
        logger.info('Login success', {mode: this.registerMode ? 'register' : 'login'});
        bus.$emit(CLOSE_OTP_EVENT);
        this.$router.push({name: HOME_ROUTE});
      },
      onOtpClosed() {
        logger.info('OTP modal closed', {
          mode: this.registerMode ? 'register' : 'login',
          captchaTokenStillSet: !!this.validateToken,
        });
        this.registerMode = false;
      },
    },
    validations: {
      mobilenumber: {
        required,
        mobileNumberValid: mobileNumberValid('mobilenumber'),
      },
      firstname: {
        required,
        alphaSpaces
      },
      middlename: {
        alphaSpaces
      },
      lastname: {
        required,
        alphaSpaces
      },
      email: {
        email
      },
      birthdate: {
        required,
        dateStringIsValid,
        dateStringIsLessThan: dateStringIsLessThan(todayInMilli)
      },
      termsAgreed: {
        requiredCheckBox
      },
      privacyAgreed: {
        requiredCheckBox
      }
    },
    bookConsultOrderObj: [
      {
        title: 'Book',
        subtitle: 'Easily connect with your doctors',
        img_src: BookImage,
      },
      {
        title: 'Consult',
        subtitle: 'Visit your doctor or consult online',
        img_src: ConsultImage,
      },
      {
        title: 'Order',
        subtitle: 'Your medicine delivered to you',
        img_src: OrderImage,
      }
    ],
    mapFieldNames: {
      firstname: 'First name',
      middlename: 'Middle name',
      lastname: 'Last name',
      birthdate: 'Date of birth',
      email: 'Email',
      termsAgreed: 'Terms & Conditions',
      privacyAgreed: 'Privacy Policy',
    },
  }
</script>

<style lang="scss">
  .auth {
    hr {
      height: 1px;
      background-color: color(lightGray, background);
      border: none;
      width: 100%;
    }

    form {
      text-align: center;
    }

    label {
      text-align: left;
    }

    .phone-input {
      .dropdown-list {
        width: 308px;
      }
    }

    .auth__content {
      padding: space(s) space(xl) !important;

      > div {
        @extend %layout--flex-col-center-y;
      }
    }

    .auth-container {
      @extend %layout--flex-col;
      flex: 1;
      justify-content: space-between;
      align-items: center;
      margin: space(base) 0;

      @include responsive(desktop) {
        justify-content: center;
      }
    }

    .terms-privacy-btn {
      text-decoration: underline;
    }

    .form-container {
      justify-content: center;
      right: 0;
    }

    .img-container {
      @include space-me($prop: margin, $b: s, $t: m);
      display: flex;
      align-content: space-between;
      align-items: center;
      justify-content: space-around;

      @include responsive(mobile) {
        flex-direction: column;
      }

      .img-box {
        margin-right: space(l);
        display: block;
        max-height: 40px;
        max-width: 40px;
        width: 100%;
        height: 100%;
      }
    }

    .now-serving-logo {
      @include responsive() {
        max-width: 200px;
        width: 100%;
        height: auto;
        margin-bottom: space(xl);
        margin-top: space(s);
      }
      max-width: 350px;
      height: 120px;
    }

    .welcome-text {
      color: color(gray, text);
    }

    .smd-checkbox__row {
      margin-bottom: 0;
    }
  }

  .auth_phone-input {
    .phone-input__dial-code {
      padding-left: 0;
    }

    .vue-country-select {
      .dropdown-arrow {
        display: none;
      }
    }
  }

  .auth__title {
    font-family: $D-DIN-Bold;
    font-size: 23px;
  }

  .auth__continue-btn, .auth__submit-btn {
    min-width: 120px !important;
  }
</style>
